export default {
    hardCapsTitle: 'Hard Caps',
    hardCapsMenu: 'Hard Caps',
    hardCapsSubtitle: 'Límites absolutos de plataforma que no se superan con plan ni add-ons',
    newHardCap: 'Nuevo hard cap',
    editHardCap: 'Editar hard cap',
    createHardCap: 'Crear hard cap',
    hardCapModule: 'Módulo',
    hardCapAttribute: 'Atributo',
    hardCapMaxValue: 'Valor máximo',
    hardCapDescription: 'Descripción',
    hardCapActive: 'Activo',
    selectModule: 'Selecciona un módulo',
    selectAttribute: 'Selecciona un atributo',
    attributeImmutableHint: 'El módulo y el atributo no se pueden cambiar después de crear',
    hardCapCreated: 'Hard cap creado exitosamente',
    hardCapUpdated: 'Hard cap actualizado exitosamente',
    hardCapCreateError: 'Error al crear el hard cap',
    hardCapUpdateError: 'Error al actualizar el hard cap',
    hardCapLoadError: 'Error al cargar los hard caps',
    confirmDeleteHardCap: '¿Está seguro que desea eliminar este hard cap? Esta acción no se puede deshacer.',
    hardCapDeleted: 'Hard cap eliminado exitosamente',
    hardCapDeleteError: 'Error al eliminar el hard cap',
    tableId: 'ID',
    tableStatus: 'Estado',
    tableActions: 'Acciones',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    validationModuleRequired: 'El módulo es obligatorio',
    validationAttributeRequired: 'El atributo es obligatorio',
    validationMaxValueRequired: 'El valor máximo es obligatorio',
};
